import { useContext, useEffect } from "react";

import { SwiperContext } from "../swiper/SwiperContext";

export function useSwiper({ tabIndex, isActive, secondaryName }: SwipeArgs) {
	const { setSelectedSlideIndex, swiperState } = useContext(SwiperContext);

	useEffect(() => {
		if (isActive) {
			setSelectedSlideIndex(tabIndex);
			swiperState?.update();
		}
	}, [isActive, tabIndex, secondaryName]);
}

export type SwipeArgs = {
	isActive: boolean;
	tabIndex: number;
	secondaryName?: string | null;
};
